function *generate () {
    let id = 0
    while(id < 1000) {
        yield id++
    }
    return id
}
const iterator = generate()
const state = {
    menu: {
        1: [ // 电商
            {
                menuId: iterator.next().value,
                selectedIcon: "merchant-a.png",
                title: "数据台",
                unselectedIcon: "merchant.png",
                url: '/databoard'
            },
            {
                menuId: iterator.next().value,
                selectedIcon: "merchant-a.png",
                title: "门店商品管理",
                unselectedIcon: "merchant.png",
                children: [
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "商品管理",
                        unselectedIcon: "merchant.png",
                        url: '/store/item'
                    },
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "订单管理",
                        unselectedIcon: "merchant.png",
                        url: '/store/order'
                    },
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "退款订单",
                        unselectedIcon: "merchant.png",
                        url: '/store/refund'
                    },
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "店铺地址",
                        unselectedIcon: "merchant.png",
                        url: '/store/address'
                    },
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "订单评价",
                        unselectedIcon: "merchant.png",
                        url: '/store/evaluate'
                    },
                    // {
                    //     menuId: iterator.next().value,
                    //     selectedIcon: "merchant-a.png",
                    //     title: "分类管理",
                    //     unselectedIcon: "merchant.png",
                    //     url: '/store/type'
                    // },
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "运费管理",
                        unselectedIcon: "merchant.png",
                        url: '/store/freight'
                    },
                ]
            },
            {
                menuId: iterator.next().value,
                selectedIcon: "merchant-a.png",
                title: "门店信息管理",
                unselectedIcon: "merchant.png",
                children: [
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "基本信息",
                        unselectedIcon: "merchant.png",
                        url: '/store/profile'
                    },
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "环境相册",
                        unselectedIcon: "merchant.png",
                        url: '/store/album'
                    },
                ]
            },
            {
                menuId: iterator.next().value,
                selectedIcon: "merchant-a.png",
                title: "消息中心",
                unselectedIcon: "merchant.png",
                url: '/message/index'
            },
            {
                menuId: iterator.next().value,
                selectedIcon: "merchant-a.png",
                title: "收支明细",
                unselectedIcon: "merchant.png",
                children: [
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "财务明细",
                        unselectedIcon: "merchant.png",
                        url: '/finance/bill'
                    },
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "银行卡管理",
                        unselectedIcon: "merchant.png",
                        url: '/finance/bank'
                    },
                ]
            },
            {
                menuId: iterator.next().value,
                selectedIcon: "merchant-a.png",
                title: "系统管理",
                unselectedIcon: "merchant.png",
                children: [
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "账号信息",
                        unselectedIcon: "merchant.png",
                        url: '/system/account'
                    },
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "操作日志",
                        unselectedIcon: "merchant.png",
                        url: '/system/log'
                    },
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "接单周期设置",
                        unselectedIcon: "merchant.png",
                        url: '/system/shopdata'
                    },
                ]
            },
        ],
        2: [ // 服务
            {
                menuId: iterator.next().value,
                selectedIcon: "merchant-a.png",
                title: "数据台",
                unselectedIcon: "merchant.png",
                url: '/databoard'
            },
            {
                menuId: iterator.next().value,
                selectedIcon: "merchant-a.png",
                title: "服务管理",
                unselectedIcon: "merchant.png",
                children: [
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "项目管理",
                        unselectedIcon: "merchant.png",
                        url: '/service/list'
                    },
                    // {
                    //     menuId: iterator.next().value,
                    //     selectedIcon: "merchant-a.png",
                    //     title: "分类管理",
                    //     unselectedIcon: "merchant.png",
                    //     url: '/service/type'
                    // },
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "服务评价",
                        unselectedIcon: "merchant.png",
                        url: '/service/evaluate'
                    },
                ]
            },
            {
                menuId: iterator.next().value,
                selectedIcon: "merchant-a.png",
                title: "服务订单",
                unselectedIcon: "merchant.png",
                children: [
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "到店服务订单",
                        unselectedIcon: "merchant.png",
                        url: '/service/storeorder'
                    },
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "上门服务订单",
                        unselectedIcon: "merchant.png",
                        url: '/service/serviceorder'
                    },
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "售后服务订单",
                        unselectedIcon: "merchant.png",
                        url: '/service/refundorder'
                    },
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "举报列表",
                        unselectedIcon: "merchant.png",
                        url: '/service/report'
                    },
                ]
            },
            {
                menuId: iterator.next().value,
                selectedIcon: "merchant-a.png",
                title: "健康师管理",
                unselectedIcon: "merchant.png",
                children: [
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "健康师列表",
                        unselectedIcon: "merchant.png",
                        url: '/health/employeelist'
                    },
                ]
            },
            {
                menuId: iterator.next().value,
                selectedIcon: "merchant-a.png",
                title: "门店信息管理",
                unselectedIcon: "merchant.png",
                children: [
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "基本信息",
                        unselectedIcon: "merchant.png",
                        url: '/store/profile'
                    },
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "环境相册",
                        unselectedIcon: "merchant.png",
                        url: '/store/album'
                    },
                ]
            },
            {
                menuId: iterator.next().value,
                selectedIcon: "merchant-a.png",
                title: "消息中心",
                unselectedIcon: "merchant.png",
                url: '/message/index'
            },
            {
                menuId: iterator.next().value,
                selectedIcon: "merchant-a.png",
                title: "收支明细",
                unselectedIcon: "merchant.png",
                children: [
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "财务明细",
                        unselectedIcon: "merchant.png",
                        url: '/finance/bill'
                    },
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "银行卡管理",
                        unselectedIcon: "merchant.png",
                        url: '/finance/bank'
                    },
                ]
            },
            {
                menuId: iterator.next().value,
                selectedIcon: "merchant-a.png",
                title: "系统管理",
                unselectedIcon: "merchant.png",
                children: [
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "账号信息",
                        unselectedIcon: "merchant.png",
                        url: '/system/account'
                    },
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "操作日志",
                        unselectedIcon: "merchant.png",
                        url: '/system/log'
                    },
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "接单周期设置",
                        unselectedIcon: "merchant.png",
                        url: '/system/shopdata'
                    },
                ]
            },
        ],
        3: [ // 全
            {
                menuId: iterator.next().value,
                selectedIcon: "merchant-a.png",
                title: "数据台",
                unselectedIcon: "merchant.png",
                url: '/databoard'
            },
            {
                menuId: iterator.next().value,
                selectedIcon: "merchant-a.png",
                title: "服务管理",
                unselectedIcon: "merchant.png",
                children: [
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "项目管理",
                        unselectedIcon: "merchant.png",
                        url: '/service/list'
                    },
                    // {
                    //     menuId: iterator.next().value,
                    //     selectedIcon: "merchant-a.png",
                    //     title: "分类管理",
                    //     unselectedIcon: "merchant.png",
                    //     url: '/service/type'
                    // },
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "服务评价",
                        unselectedIcon: "merchant.png",
                        url: '/service/evaluate'
                    },
                ]
            },
            {
                menuId: iterator.next().value,
                selectedIcon: "merchant-a.png",
                title: "服务订单",
                unselectedIcon: "merchant.png",
                children: [
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "到店服务订单",
                        unselectedIcon: "merchant.png",
                        url: '/service/storeorder'
                    },
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "上门服务订单",
                        unselectedIcon: "merchant.png",
                        url: '/service/serviceorder'
                    },
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "售后服务订单",
                        unselectedIcon: "merchant.png",
                        url: '/service/refundorder'
                    },
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "举报列表",
                        unselectedIcon: "merchant.png",
                        url: '/service/report'
                    },
                ]
            },
            {
                menuId: iterator.next().value,
                selectedIcon: "merchant-a.png",
                title: "门店商品管理",
                unselectedIcon: "merchant.png",
                children: [
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "商品管理",
                        unselectedIcon: "merchant.png",
                        url: '/store/item'
                    },
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "订单管理",
                        unselectedIcon: "merchant.png",
                        url: '/store/order'
                    },
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "退款订单",
                        unselectedIcon: "merchant.png",
                        url: '/store/refund'
                    },
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "店铺地址",
                        unselectedIcon: "merchant.png",
                        url: '/store/address'
                    },
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "订单评价",
                        unselectedIcon: "merchant.png",
                        url: '/store/evaluate'
                    },
                    // {
                    //     menuId: iterator.next().value,
                    //     selectedIcon: "merchant-a.png",
                    //     title: "分类管理",
                    //     unselectedIcon: "merchant.png",
                    //     url: '/store/type'
                    // },
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "运费管理",
                        unselectedIcon: "merchant.png",
                        url: '/store/freight'
                    },
                ]
            },
            {
                menuId: iterator.next().value,
                selectedIcon: "merchant-a.png",
                title: "健康师管理",
                unselectedIcon: "merchant.png",
                children: [
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "健康师列表",
                        unselectedIcon: "merchant.png",
                        url: '/health/employeelist'
                    },
                ]
            },
            {
                menuId: iterator.next().value,
                selectedIcon: "merchant-a.png",
                title: "门店信息管理",
                unselectedIcon: "merchant.png",
                children: [
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "基本信息",
                        unselectedIcon: "merchant.png",
                        url: '/store/profile'
                    },
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "环境相册",
                        unselectedIcon: "merchant.png",
                        url: '/store/album'
                    },
                ]
            },
            {
                menuId: iterator.next().value,
                selectedIcon: "merchant-a.png",
                title: "消息中心",
                unselectedIcon: "merchant.png",
                url: '/message/index'
            },
            {
                menuId: iterator.next().value,
                selectedIcon: "merchant-a.png",
                title: "收支明细",
                unselectedIcon: "merchant.png",
                children: [
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "财务明细",
                        unselectedIcon: "merchant.png",
                        url: '/finance/bill'
                    },
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "银行卡管理",
                        unselectedIcon: "merchant.png",
                        url: '/finance/bank'
                    },
                ]
            },
            {
                menuId: iterator.next().value,
                selectedIcon: "merchant-a.png",
                title: "系统管理",
                unselectedIcon: "merchant.png",
                children: [
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "账号信息",
                        unselectedIcon: "merchant.png",
                        url: '/system/account'
                    },
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "操作日志",
                        unselectedIcon: "merchant.png",
                        url: '/system/log'
                    },
                    {
                        menuId: iterator.next().value,
                        selectedIcon: "merchant-a.png",
                        title: "接单周期设置",
                        unselectedIcon: "merchant.png",
                        url: '/system/shopdata'
                    },
                ]
            },
        ]
    }
}
const getters = {
    getMenu(state) {
        return state.menu
    }
}
const mutations = {

}

const actions = {
    
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}